import styled, { css } from 'styled-components';

export const Controls = styled.div`
  ${({ theme }) => css`
    a {
      color: ${theme.colors.gray[100]};
    }
  `}
`;
